export default __webpack_public_path__ + "static/media/HV_Icones_Plan_white.1e74b727.svg";